<template>
  <page-outline :title="changePassword_title">
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
    </template>
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="mb-4">
          <b-col>
            <form-card-wrapper
              :label="$t('common.idtfr')"
              :readOnlyValue="login">
            </form-card-wrapper>
          </b-col>
        </b-row>
        
        <b-row v-if="!connectToGoogle" class="mb-4">
          <b-col>
            <form-card-wrapper
              :label="$t('common.orig_pwd')"
              controlId="originalPassword"
              :required="true">
              <div class="d-flex align-items-center">
                <input id="originalPassword"
                  v-model="originalPassword"
                  class="form-control"
                  :type="currentPasswordType"
                  :placeholder="$t('common.orig_pwd')"
                  :aria-required="true"
                  :aria-describedby="originalPasswordError">
                <button type="button" 
                  class="password-toggle-btn ml-2"
                  :aria-label="isCurrentPasswordFieldHidden ? $t('common.show_password') : $t('common.hide_password')"
                  @click="switchCurrentPasswordType"
                  @keydown.enter="switchCurrentPasswordType"
                  @keydown.space.prevent="switchCurrentPasswordType">
                  <i :class="[isCurrentPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"></i>
                </button>
              </div>
            </form-card-wrapper>
          </b-col>
        </b-row>
        
        <b-row v-if="!connectToGoogle" class="mb-4">
          <b-col>
            <form-card-wrapper
              :label="$t('common.new_pwd')"
              controlId="newPassword"
              :required="true">
              <div class="d-flex align-items-center">
                <input id="newPassword"
                  v-model="newPassword"
                  class="form-control"
                  :type="newPasswordType"
                  :placeholder="$t('common.new_pwd')"
                  :aria-required="true"
                  :aria-describedby="newPasswordError">
                <button type="button" 
                  class="password-toggle-btn ml-2"
                  :aria-label="isNewPasswordFieldHidden ? $t('common.show_password') : $t('common.hide_password')"
                  @click="switchNewPasswordType"
                  @keydown.enter="switchNewPasswordType"
                  @keydown.space.prevent="switchNewPasswordType">
                  <i :class="[isNewPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"></i>
                </button>
              </div>
            </form-card-wrapper>
          </b-col>
        </b-row>
        
        <b-row class="mb-4">
          <b-col>
            <form-card-wrapper
              :label="$t('common.conf_pwd')"
              controlId="confirmNewPassword"
              :required="true">
              <div class="d-flex align-items-center">
                <input id="confirmNewPassword"
                  v-model="confirmNewPassword"
                  class="form-control"
                  :type="confirmNewPasswordType"
                  :placeholder="$t('common.conf_pwd')"
                  :aria-required="true"
                  :aria-describedby="confirmPasswordError">
                <button type="button" 
                  class="password-toggle-btn ml-2"
                  :aria-label="isConfirmNewPasswordFieldHidden ? $t('common.show_password') : $t('common.hide_password')"
                  @click="switchConfirmNewPasswordType"
                  @keydown.enter="switchConfirmNewPasswordType"
                  @keydown.space.prevent="switchConfirmNewPasswordType">
                  <i :class="[isConfirmNewPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"></i>
                </button>
              </div>
            </form-card-wrapper>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <template slot="bottomActions">
      <app-button
        :text="$t('common.sve')"
        icon="fa-light fa-floppy-disk"
        variant="primary"
        :title="changePassword_Validatechanges"
        @click="changePassword">
      </app-button>
    </template>
  </page-outline>
</template>

<script>
import AppButton from '@/components/common/AppButton.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import FormCardWrapper from '@/components/common/FormCardWrapper.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    AppButton,
    'bottom-toolbar': bottomToolbar,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'form-card-wrapper': FormCardWrapper
  },
  computed: {
    isCurrentPasswordFieldHidden () {
      return this.currentPasswordType === 'password'
    },
    isConfirmNewPasswordFieldHidden () {
      return this.confirmNewPasswordType === 'password'
    },
    isNewPasswordFieldHidden () {
      return this.newPasswordType === 'password'
    }
  },
  data () {
    return {
      colorBottomButton: this.$engine.firstOn().services.getButtonClassColorById(this.$engine.firstOn().user.currentService.id),
      isSmartphone: false,
      login: '',
      originalPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      connectToGoogle: false,
      confirmNewPasswordType: 'password',
      currentPasswordType: 'password',
      newPasswordType: 'password',
      returnUrl: '/profile/',
      originalPasswordError: '',
      newPasswordError: '',
      confirmPasswordError: ''
    }
  },
  created () {
    this.changePassword_title = this.$i18n.t('common.chg_pwd')
    this.changePassword_Validatechanges = this.$i18n.t('common.valid_chgs')
    /* if (this.$engine.firstOn().services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    } */
    /* this.login = this.$engine.firstOn().user.get().identifier */
    this.getUserAccountInfo()
  },
  mounted () {
    this.connectToGoogle = false
  },
  methods: {
    goBack () {
      loadPage(this, {url: this.returnUrl, force: false, ignoreCache: false})
    },
    changePasswordAPI (connectBy) {
      let that = this
      this.$engine.firstOn().user.changePassword({
        originalPassword: this.originalPassword,
        newPassword: this.newPassword,
        'connectBy': connectBy
      })
      .then(response => {
        if (response.status === 200) {
          this.$engine.firstOn().user.connectBy = 'login-password-capi'
          that.$f7.modal({
            title: this.$t('common.security.password_modified'),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/profile/', force: false, ignoreCache: false})
          }, 2000)
        }
      })
      .catch(error => {
        if (error.response.data.error === 'oldPassword not valid') {
          that.$f7.modal({
          title: that.$t('profilesPage.password_old_not_valid'),
          text: that.$t('profilesPage.password_old_not_match'),
          buttons: [
            {
              text: this.$t('common.cncl'),
              onClick: function () {
                return
              }
            }
          ]
        })
      } else if (error.response.data.error === 'newPasswordAlreadyUsed') {
          that.$f7.modal({
          title: that.$t('profilesPage.new_password_used'),
          text: that.$t('profilesPage.new_password_used_7_pwd'),
          buttons: [
            {
              text: this.$t('common.cncl'),
              onClick: function () {
                return
              }
            }
          ]
        })
      } else {
          errorMessageAlert(error, that)
        }
      })
    },
    changePassword () {
      let that = this
      let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      if (that.originalPassword === '' && this.$engine.firstOn().user.connectBy !== 'vue-google-oauth2') {
        that.$f7.alert(that.$i18n.t('profilesPage.password_original_missing'), that.$i18n.t('common.error_title'))
      } else if (that.newPassword === '') {
        that.$f7.alert(that.$i18n.t('errors.new_pwd_mssng'), that.$i18n.t('common.error_title'))
      } else if (that.confirmNewPassword === '') {
        that.$f7.alert(that.$i18n.t('errors.cnfrm_pwd'), that.$i18n.t('common.error_title'))
      } else if (!regexPassword.test(that.newPassword)) {
        that.$f7.alert(that.$i18n.t('profilesPage.password_wrong_format'), that.$i18n.t('common.error_title'))
      } else if (that.newPassword !== that.confirmNewPassword) {
        that.$f7.alert(that.$i18n.t('common.security.passwords_not_matching'), that.$i18n.t('common.error_title'))
      } else if (that.originalPassword === that.newPassword) {
        that.$f7.alert(that.$i18n.t('common.security.password_same'), that.$i18n.t('common.error_title'))
      } else {
        var connectBy = 'lpc'
        if (this.$engine.firstOn().user.connectBy === 'vue-google-oauth2') {
          connectBy = 'vgo'
          // On se conecte via Google
          this.$gAuth.signIn()
          .then(GoogleUser => {
            that.changePasswordAPI(connectBy)
          })
          .catch(error => {
            errorMessageAlert(error, that)
          })
        } else {
          this.changePasswordAPI(connectBy)
        }
      }
    },
    getUserAccountInfo () {
      let info = this.$engine.firstOn().accounts.get()
      let userAccounts
      let userAccountId

      userAccounts = info[0].userAccts
      userAccountId = info[0].userAccountId
      userAccounts = userAccounts.filter((account) => account.id === userAccountId)
      this.updateUserAccountInfo(userAccounts)
    },
    switchConfirmNewPasswordType () {
      if (this.confirmNewPasswordType === 'password') {
        this.confirmNewPasswordType = 'text'
      } else {
        this.confirmNewPasswordType = 'password'
      }
    },
    switchCurrentPasswordType () {
      if (this.currentPasswordType === 'password') {
        this.currentPasswordType = 'text'
      } else {
        this.currentPasswordType = 'password'
      }
    },
    switchNewPasswordType () {
      if (this.newPasswordType === 'password') {
        this.newPasswordType = 'text'
      } else {
        this.newPasswordType = 'password'
      }
    },
    updateUserAccountInfo (userAccount) {
      let userAccountInfo = userAccount
      this.login = userAccountInfo[0].login
      /* this.userName = userAccountInfo[0].name
      this.userProfile = userAccountInfo[0].profile */
    }
  }
}
</script>
<style scoped>
.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 100%
}

/* Boutons de basculement mot de passe accessibles */
.password-toggle-btn {
    background: none;
    border: none;
    padding: 8px;
    cursor: pointer;
    color: #6c757d;
    outline: none;
    border-radius: 4px;
    flex-shrink: 0;
}

.password-toggle-btn:hover,
.password-toggle-btn:focus {
    background-color: #f8f9fa;
    color: #495057;
    outline: 2px solid #007bff;
    outline-offset: 2px;
}

.password-toggle-btn:active {
    background-color: #e9ecef;
}

</style>
